export { TimetableModule } from './TimetableModule'
export const timetablePath = '/et/company/:companyId/timetableModule'
